import {
  breakfast,
  fullMealIncluded,
  halfMealIncluded,
  noMealIncluded,
} from '@config/icons'
import type {
  Hotels,
  MealIncludedCodes,
  Rates,
} from '@entities/avail/dtos/availDTO'
import _ from 'lodash'

import i18n from '@/shared/infra/translation'

interface MealsProps {
  code: 'SP' | 'AI' | 'CM' | 'MP' | 'MA' | 'MJ' | 'PC'
  name: string
  iconPath: string
}

const meals: MealsProps[] = [
  {
    code: 'SP',
    name: i18n.t('SP'),
    iconPath: noMealIncluded,
  },
  {
    code: 'AI',
    name: i18n.t('AI'),
    iconPath: fullMealIncluded,
  },
  {
    code: 'CM',
    name: i18n.t('CM'),
    iconPath: breakfast,
  },
  {
    code: 'MP',
    name: i18n.t('MP'),
    iconPath: halfMealIncluded,
  },
  {
    code: 'MA',
    name: i18n.t('MA'),
    iconPath: halfMealIncluded,
  },
  {
    code: 'MJ',
    name: i18n.t('MJ'),
    iconPath: halfMealIncluded,
  },
  {
    code: 'PC',
    name: i18n.t('PC'),
    iconPath: fullMealIncluded,
  },
]

export function findCodeById(id: string, hotel: Hotels): any {
  let code = ''
  hotel.rates.forEach((rate: Rates) => {
    if (rate.id.toString() === id) code = rate.mealIncluded.code
  })
  return code
}

export function getMealIncludedValue(code: string): MealsProps {
  return _.find(meals, { code }) as MealsProps
}

export function getMealByName(name: string): MealIncludedCodes {
  const findMeal = _.find(meals, { name })

  return {
    code: findMeal?.code || 'SP',
    id: 0,
    value: findMeal?.name || 'SEM PENSÃO',
  }
}
